import React from 'react';

const CheckMark = () => (
  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 10.71L0 5.70999L1.41 4.29999L5 7.87999L12.59 0.289993L14 1.70999L5 10.71Z" fill="currentColor" />
  </svg>
);

export default CheckMark;
